module.exports = __webpack_public_path__ + "static/media/SL 16.d5d275e5.mp3";